import { memo, useRef } from "react";
import { propEq, equals, pick, map, filter, pipe, pluck } from "ramda";
import { Flex, Paper, IconButton } from "@base-ui";
import { ExportPngButton, ExportExcelButton } from "@interdependence-ui";
import GraphDescription from "@dataVisualizations/graphDescription/GraphDescription";
import Timeline from "@dataVisualizations/timeline/Timeline";
import Barchart from "@dataVisualizations/barchart/Barchart";
import StackedBarchart from "@dataVisualizations/stackedBarchart/StackedBarchartWrapper";
import Header from "./headerblock/Header";
import AccordionDescriptions from "./accordionDescriptions/AccordionDescriptions";
import MetaInformation from "./metaInformation/MetaInformation";
import TableAccordion from "./measurementstable/TableAccordion";
import { useMeasuresContext } from "@webapi/contexts/measures";
import { getIsoDate } from "utils/dates";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function MeasureDetailView(props) {
  var _metadata$information;
  var metadata = props.metadata,
    query = props.query,
    setQuery = props.setQuery,
    organizations = props.organizations,
    loading = props.loading;
  var exportPngRef = useRef();
  var _useMeasuresContext = useMeasuresContext(),
    lookupParentMeasure = _useMeasuresContext.lookupParentMeasure;
  var measure = lookupParentMeasure(metadata === null || metadata === void 0 ? void 0 : metadata.parentMeasure);
  var activeSubmeasures = pipe(map(function (id) {
    var _measure$submeasures;
    return measure === null || measure === void 0 ? void 0 : (_measure$submeasures = measure.submeasures) === null || _measure$submeasures === void 0 ? void 0 : _measure$submeasures.find(propEq("measureId", id));
  }), filter(Boolean))(query.measureIds);
  var genders = pluck("gender", activeSubmeasures);
  var ages = pluck("age", activeSubmeasures).filter(Boolean);
  var exportPayload = {
    OrganizationIds: query.units,
    ParentMeasureIds: [metadata === null || metadata === void 0 ? void 0 : metadata.parentMeasure],
    StartDate: query.dateFrom,
    EndDate: query.dateTo,
    Gender: genders.length > 0 ? genders : ["Total"]
  };
  var isBarchart = query.graphSelected === "barchart";
  var isNotProcent = measure.measureUnit !== "%";
  var graphSelected = isBarchart && isNotProcent && activeSubmeasures.length > 1 ? "stackedBarchart" : query.graphSelected;
  var Graph = {
    timeline: Timeline,
    barchart: Barchart,
    stackedBarchart: StackedBarchart
  }[graphSelected];
  var exportPng = /*#__PURE__*/_jsx(ExportPngButton, {
    exportRef: exportPngRef,
    fileName: "".concat(measure === null || measure === void 0 ? void 0 : measure.name, "_").concat(query.periodType, "_").concat(getIsoDate(query.dateFrom), "-").concat(getIsoDate(query.dateTo)),
    width: "fit-content",
    entry: "Indikatorsidan"
  });
  var exportExcel = /*#__PURE__*/_jsx(ExportExcelButton, {
    entry: "Indikatorsidan",
    fileName: "".concat(measure === null || measure === void 0 ? void 0 : measure.name, "_").concat(query.periodType, "_").concat(getIsoDate(query.dateFrom), "-").concat(getIsoDate(query.dateTo), ".xlsx"),
    payload: exportPayload
  });
  return /*#__PURE__*/_jsxs(Flex.Column, {
    ref: exportPngRef,
    className: "pre-png-export export-png-holder",
    children: [/*#__PURE__*/_jsx(Header, {
      title: metadata === null || metadata === void 0 ? void 0 : metadata.library[metadata.parentMeasure].label,
      ingress: metadata === null || metadata === void 0 ? void 0 : metadata.measureDefinition,
      soughtValue: metadata === null || metadata === void 0 ? void 0 : metadata.soughtValue
    }), /*#__PURE__*/_jsx("div", {
      className: "remove-pre-png",
      style: {
        marginBottom: "20px"
      }
    }), /*#__PURE__*/_jsxs(Paper.Row, {
      p: "sm",
      display: "block",
      children: [/*#__PURE__*/_jsx(Flex.Row, {
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex"
          },
          children: [exportPng, exportExcel, /*#__PURE__*/_jsx(IconButton, {
            style: {
              minWidth: "unset"
            },
            id: "print-button",
            label: "Skriv ut denna sida",
            title: "Skriv ut denna sida",
            icon: "print",
            inverted: true,
            onClick: function onClick() {
              return window.print();
            }
          })]
        })
      }), /*#__PURE__*/_jsx(Graph, {
        id: query.graphSelected,
        query: query,
        setQuery: setQuery,
        measure: measure,
        measures: measure && [measure] || [],
        lookupOrganization: function lookupOrganization(id) {
          return organizations === null || organizations === void 0 ? void 0 : organizations.find(propEq("id", id));
        },
        allowGraphInteractions: true,
        changeToSingleDateAndBarchart: function changeToSingleDateAndBarchart(dateTo) {
          return setQuery({
            dateTo: dateTo
          });
        },
        loading: loading
      }), /*#__PURE__*/_jsx(GraphDescription, {
        periodType: query.periodType,
        genders: genders.length > 0 ? genders : ["Total"],
        age: ages.length > 0 ? ages : ["Totalt"],
        informationSource: metadata === null || metadata === void 0 ? void 0 : (_metadata$information = metadata.informationSource) === null || _metadata$information === void 0 ? void 0 : _metadata$information.name
      }), /*#__PURE__*/_jsxs("div", {
        className: "remove-pre-png",
        children: [/*#__PURE__*/_jsx(TableAccordion, {
          measure: measure,
          query: query
        }), /*#__PURE__*/_jsxs(Flex.Row, {
          breakpoint: "sm",
          id: "about-indicator",
          children: [/*#__PURE__*/_jsx(AccordionDescriptions, {
            metadata: metadata
          }), /*#__PURE__*/_jsx(MetaInformation, {
            metadata: metadata
          })]
        })]
      })]
    })]
  });
}, function (prev, curr) {
  return equals(pick(["query", "metadata", "measurementsWithMetadata", "loading"], prev), pick(["query", "metadata", "measurementsWithMetadata", "loading"], curr));
});